import {
  string as yupString,
  object as yupObject,
  boolean as yupBoolean,
  number as yupNumber,
} from 'yup';
import * as Yup from 'yup';

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const formAdvertiserValidationSchema = yupObject().shape({
  name: yupString()
    .min(2, 'Name is too short')
    .max(255, 'Name is too long')
    .required('Required'),
  contactName: yupString()
    .min(2, 'Contact name is too short')
    .max(255, 'Contact name is too long')
    .required('Required'),
  email: yupString()
    .email('Invalid email')
    .required('Required'),
  imageUrl: yupString().required('Required'),
});

export const formAdminValidationSchema = yupObject().shape({
  firstName: yupString()
    .min(2, 'First name is too short')
    .max(255, 'First name is too long')
    .required('Required'),
  lastName: yupString()
    .min(2, 'Last name is too short')
    .max(255, 'Last name is too long')
    .required('Required'),
  email: yupString()
    .email('Invalid email')
    .required('Required'),
  phone: yupString()
    .required('Required')
    .matches(phoneRegExp, 'Phone number is not valid')
    .min(8, 'Phone number is too short')
    .max(10, 'Phone number is too long'),
});

export const postsValidationSchema = yupObject().shape({
  id: yupString().required('Required'),
  mediaCount: yupNumber(),
  feedback: yupString(),
  updatedCaption: yupString(),
  accepted: yupBoolean(),
  publishDate: yupString(),
});

export const formCampaignValidationSchema = yupObject().shape({
  advertiserId: yupString().required('Required'),
  title: yupString().required('Required'),
  description: yupString().required('Required'),
  draftDeadline: yupString()
    .nullable()
    .required('Required'),
  startDate: yupString()
    .nullable()
    .required('Required'),
  endDate: yupString()
    .nullable()
    .required('Required'),
  imageUrl: yupString().required('Required'),
  terms: yupString().required('Terms missing'),
});

export const formLoginValidationSchema = yupObject().shape({
  password: yupString().required('Required'),
  email: yupString()
    .email('Invalid email')
    .required('Required'),
});

export const formSetPasswordValidationSchema = yupObject().shape({
  password: yupString().required('Required'),
  confirmPassword: yupString().required('Required'),
});

export const formResetPasswordValidationSchema = yupObject().shape({
  email: yupString()
    .email('Invalid email')
    .required('Required'),
});

export const formInspirationValidationSchema = yupObject().shape({
  title: yupString()
    .min(1, 'Title is too short')
    .required('Required'),
  countryCodes: Yup.array()
    .min(1)
    .required('Required'),
  imageUrls: Yup.array()
    .min(1)
    .required('Required'),
});
